import normalizeUrl from 'normalize-url';
import routes from '../routes';
import { getResortLocationUrl, getResortShortName } from '../utilities/lodgeData';
import { SITE_NIAGON, TERMS_AND_CONDITIONS_SUFFIX, WRITE_LOCAL_STORAGE_DEBOUNCE_TIMEOUT } from './constants';
/**
 * Returns items to be added in the My Account - mobile user menu dropdown.
 */
/**
 * Returns items to be added in the user menu dropdown
 */
export const getLoggedInUserDropdownItems = resortLocationUrlParam => [
  {
    name: 'My Profile',
    url: `${resortLocationUrlParam}${routes.profile.self.replace('/', '')}` // remove the first and last slash in the URL, since resortLocationUrlParam has already an ending slash '/'
  },
  {
    name: 'Refer a Friend',
    url: `${resortLocationUrlParam}${routes.referAFriend.replace('/', '')}` // remove the first and last slash in the URL, since resortLocationUrlParam has already an ending slash '/'
  },
  {
    name: 'My Preferences',
    url: `${resortLocationUrlParam}${routes.profile.myPreferences.replace('/', '').replace(/\/$/, '')}` // remove the first and last slash in the URL, since resortLocationUrlParam has already an ending slash '/'
  },
  {
    name: 'My Reservations',
    url: `${resortLocationUrlParam}${routes.reservations.myReservations.self.replace('/', '')}` // remove the first slash in the URL, since resortLocationUrlParam has already an ending slash '/'
  },
  {
    name: 'My Recent Searches',
    url: `${resortLocationUrlParam}${routes.myRecentSearches.replace('/', '')}` // remove the first slash in the URL, since resortLocationUrlParam has already an ending slash '/'
  },
  {
    name: 'Sign Out',
    url: '#'
  }
];

/**
 * When the user hit Sign out in the middle of this routes, then the app is redirected to the home page
 */
export const routesRedirectOnSignOut = [
  '/user/profile',
  '/user/refer-a-friend',
  '/plan/payment-success',
  '/plan/confirmation',
  '/daypass/payment-success',
  '/daypass/confirmation',
  '/reservations/my-reservations',
  '/my-recent-searches'
];

export const shouldReloadRoutes = [
  routes.seasonpass.booking,
  routes.daypass.booking,
  routes.plan.payment,
  routes.daypass.payment,
  routes.seasonpass.payment,
  routes.birthdayParties.payment
];

/**
 * Checks if the current site is niagara
 * @param {string} resortLocation. App resort location information
 */
export const checkIfIsNiagaraProperty = resortLocation => {
  return resortLocation === SITE_NIAGON;
};

/**
 * Orders and routes configs for Navigation Menu
 */
export const NAV_MENU_FLOWS = {
  primary: [
    {
      route: routes.profile.self,
      title: 'My Profile'
    },
    {
      route: routes.reservations.myReservations.self,
      title: 'My Reservations'
    },
    {
      route: routes.myRecentSearches,
      title: 'My Recent Searches'
    },
    {
      route: routes.profile.myPreferences,
      title: 'My Preferences'
    }
  ]
};

/**
 * Compare two pathnames by normalize them first
 * @param {string} firstUrl First pathname to compare
 * @param {string} secondUrl Second pathname to compare
 * @returns boolean
 */
export const compareUrlPathnames = (firstUrl, secondUrl) => {
  if (firstUrl === secondUrl) return true;

  // check if any of the urls is a root url (only '/')
  if (firstUrl === '/' || secondUrl === '/') return false;

  // remove start slash, only if there is an slash at the begining of the string
  // because starting ones throw an error
  return normalizeUrl(firstUrl.replace(/^\//, '')) === normalizeUrl(secondUrl.replace(/^\//, ''));
};

/**
 * Concatenates the terms link of a suite
 * @returns string
 */
export const getTermsAndConditionUrl = () => {
  return `${TERMS_AND_CONDITIONS_SUFFIX}`;
};

export const removeTrailingSlash = urlPath => (urlPath.endsWith('/') ? urlPath.slice(0, -1) : urlPath);

// Combine multiple portions of a path into a single URL
export const joinPaths = (basePath, childPath) =>
  `${basePath}${childPath.startsWith('/') ? '' : '/'}${removeTrailingSlash(childPath)}`;

/*
 Navigates (via full page reload) *after* Redux state has been written to localStorage.
 This delay ensures the state is saved before reload, since configureStore.js
 writes to localStorage with a 100ms debounce (WRITE_LOCAL_STORAGE_DEBOUNCE_TIMEOUT).
 Without this delay, Redux might not rehydrate correctly after reload.

 Pass shouldReplaceHistoryEntry when the page being left is a one-shot link that must not be
 reachable with the Back button, such as the cart handoff's ?cartId= URL.
*/
export const delayedNavigation = (targetUrl, { shouldReplaceHistoryEntry = false } = {}) => {
  setTimeout(() => {
    if (shouldReplaceHistoryEntry) return window.location.replace(targetUrl);

    window.location.href = targetUrl;
  }, WRITE_LOCAL_STORAGE_DEBOUNCE_TIMEOUT + 10);
};

export const routeToSeasonPassRedeemWithReload = () => {
  window.location.href = `/${getResortShortName()}${routes.seasonpass.redeem}`;
};

export const navigateToPHP = () => {
  window.location.pathname = getResortLocationUrl();
};
